


















import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardDataCard from "./DashboardDataCard.vue";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";

@Component({
  components: {
    DashboardDataCard,
  },
})
export default class DashboardHistoricalCard extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public period!: string; // "Hier", "Semaine dernière", etc.
  @Prop() public keyIndex!: string;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;
  @Prop({ default: "" }) public styleClass!: string;
  @Prop({ default: () => ({}) }) public styleObject!: object;
  @Prop({ default: false }) public finalPeriod!: boolean;

  get borderStyle(): string {
    return "border: 2px solid #0d47a1; padding: 10px 0 25px 0 !important";
  }

  get computedStyle(): string {
    const baseStyle = this.borderStyle;
    if (!this.styleObject || Object.keys(this.styleObject).length === 0) {
      return baseStyle;
    }

    const customStyle = Object.entries(this.styleObject)
      .map(([key, value]) => `${key}: ${value}`)
      .join("; ");

    return `${baseStyle}; ${customStyle}`;
  }

  public onRenderFinished() {
    this.$emit("renderFinished");
  }

  public onUpdate() {
    if (this.finalPeriod) {
      this.$emit("init");
    } else {
      this.$emit("renderFinished");
    }
  }
}
